(function(){
  var root = document.getElementById('wq-page');
  if(!root) return;
  var reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- Store constants ---------- */
  var QN_TEL = '+15163000944';
  var QN_TEL_DISPLAY = '(516) 300-0944';
  var EMAIL = 'info@wilsonebikes.com';
  var STORE_NAME = 'Wilson\u2019s NYC';

  /* Eastern-time clock helper */
  function etParts(){
    try {
      var parts = new Intl.DateTimeFormat('en-US', {
        timeZone:'America/New_York', hour:'2-digit', minute:'2-digit', hour12:false, month:'numeric'
      }).formatToParts(new Date());
      var o = { hour:0, minute:0, month:7 };
      parts.forEach(function(p){
        if(p.type === 'hour') o.hour = parseInt(p.value, 10) % 24;
        if(p.type === 'minute') o.minute = parseInt(p.value, 10);
        if(p.type === 'month') o.month = parseInt(p.value, 10);
      });
      return o;
    } catch(e){
      var d = new Date();
      return { hour:d.getHours(), minute:d.getMinutes(), month:d.getMonth()+1 };
    }
  }
  function etDayName(){
    try {
      return new Intl.DateTimeFormat('en-US', { timeZone:'America/New_York', weekday:'long' }).format(new Date());
    } catch(e){
      var days = ['Sunday','Monday','Tuesday','Wednesday','Thursday','Friday','Saturday'];
      return days[new Date().getDay()];
    }
  }
  function nyHoursForMonth(m){
    // Flushing shop hours: 10:30AM-7PM (ET), every day, year-round
    return { open:630, close:1140 }; // minutes
  }
  function nyHoursToday(){
    return nyHoursForMonth(etParts().month);
  }
  function fmt12(mins){
    var h = Math.floor(mins/60), mm = mins % 60;
    var ap = h >= 12 ? 'PM' : 'AM';
    var hh = h % 12; if(hh === 0) hh = 12;
    return hh + ':' + ('0'+mm).slice(-2) + ' ' + ap;
  }


  /* ---------- HUB Booking flow: Ride > Issue > Shop > Time > Send ---------- */
  var SHOPS = {
    queens:   { name:'Wilson\u2019s Queens', shortName:'Queens \u00b7 Elmhurst', addr:'82-15 Queens Blvd, Elmhurst', tel:'+15163000944', telDisplay:'(516) 300-0944' },
    brooklyn: { name:'Wilson\u2019s Brooklyn', shortName:'Brooklyn \u00b7 E. Williamsburg', addr:'268 Richardson St, East Williamsburg', tel:'+15163000944', telDisplay:'(516) 300-0944' },
    lic:      { name:'Wilson\u2019s Long Island City', shortName:'Long Island City', addr:'41-13 31st Ave, Long Island City', tel:'+15163000944', telDisplay:'(516) 300-0944' },
    flushing: { name:'Wilson\u2019s Flushing', shortName:'Flushing \u00b7 Downtown', addr:'35-23 Farrington St, Flushing', tel:'+15163000944', telDisplay:'(516) 300-0944' }
  };
  function shopHoursForMonth(shopKey, m){
    // All four NYC shops: 10:30AM-7PM year-round. Brooklyn + LIC are closed Sunday (shopClosedSunday).
    return { open:630, close:1140 };
  }
  function shopClosedSunday(shopKey){ return shopKey === 'brooklyn' || shopKey === 'lic'; }

  var state = { ride:'', issue:'', shop:'', date:'', dateLabel:'', time:'' };
  var step = 1, TOTAL = 5;
  var panes = root.querySelectorAll('.wq-bp-pane');
  var crumbs = root.querySelectorAll('.wq-bp-crumb');
  var back  = document.getElementById('wq-back');
  var daysEl = document.getElementById('wq-bp-days');
  var timesEl = document.getElementById('wq-bp-times');
  var dayLabelEl = document.getElementById('wq-bp-daylabel');
  var topLocEl = document.getElementById('wq-bp-toploc');

  function setPass(key, val){
    var row = document.getElementById('wq-pass-' + key);
    if(!row) return;
    var v = row.querySelector('b');
    if(val){
      v.textContent = val;
      row.classList.add('wq-bp-row-set');
    } else {
      v.textContent = '\u2014';
      row.classList.remove('wq-bp-row-set');
    }
  }

  function show(n){
    step = n;
    panes.forEach(function(p){ p.hidden = (+p.dataset.pane !== n); });
    crumbs.forEach(function(c){
      var st = +c.dataset.step;
      c.classList.toggle('wq-bp-on', st === n);
      c.classList.toggle('wq-bp-done', st < n);
    });
    if(back) back.hidden = (n === 1);
    if(n === 4 && !state.date && state.shop) initDateTimeStep();
    if(n === TOTAL) buildLinks();
  }
  crumbs.forEach(function(c){
    c.addEventListener('click', function(){
      var st = +c.dataset.step;
      if(st < step) show(st);
    });
  });

  function esc(t){ var e=document.createElement('span'); e.textContent=t||''; return e.innerHTML; }

  function buildLinks(){
    var nameEl = document.getElementById('wq-field-name');
    var phoneEl = document.getElementById('wq-field-phone');
    var descEl = document.getElementById('wq-field-desc');
    var emailEl = document.getElementById('wq-field-email');
    var modelEl = document.getElementById('wq-field-model');
    var name = nameEl ? nameEl.value.trim() : '';
    var phone = phoneEl ? phoneEl.value.trim() : '';
    var desc = descEl ? descEl.value.trim() : '';
    var slotTxt = (state.dateLabel && state.time) ? (state.dateLabel + ' \u00b7 ' + state.time + ' ET') : '';
    var shop = SHOPS[state.shop] || SHOPS.queens;

    setPass('name', name);

    var msg = 'Hi ' + shop.name + '! I\u2019d like to book a repair at ' + shop.addr + '.\n'
      + 'Ride: ' + state.ride + '\n'
      + 'Issue(s): ' + state.issue + '\n'
      + (slotTxt ? 'Requested slot: ' + slotTxt + '\n' : '')
      + 'My name: ' + (name || '____') + '\n'
      + 'My phone: ' + (phone || '____')
      + (desc ? '\nDetails: ' + desc : '');

    var txtEl = document.getElementById('wq-cta-text');
    var emlEl = document.getElementById('wq-cta-email');
    var calEl = document.getElementById('wq-cta-call');
    var numEl = document.getElementById('wq-call-number');
    if(txtEl) txtEl.href = 'sms:' + shop.tel + '?&body=' + encodeURIComponent(msg);
    if(emlEl) emlEl.href = 'mailto:' + EMAIL + '?subject=' + encodeURIComponent(shop.shortName + ' Repair Booking \u2014 ' + state.ride) + '&body=' + encodeURIComponent(msg);
    if(calEl) calEl.href = 'tel:' + shop.tel;
    if(numEl) numEl.textContent = 'Call ' + shop.telDisplay + ' \u2014 ' + shop.shortName;
  }

  /* ---------- Confirm Booking: writes straight to the selected shop's Google Calendar ----------
     This hub page's shop keys (queens/brooklyn/lic/flushing) don't match the Apps Script
     bridge's shop keys 1:1 \u2014 queens is Elmhurst's calendar, lic is long-island-city's. */
  var BOOKING_ENDPOINT = "https://script.google.com/macros/s/AKfycby779T-3RrEgFYlNe6ERqyh9r67Ly4GFmeWLabXWf7-QRYV-6tZ3XPlsq_G7Z-rLV5Nsg/exec";
  var BOOKING_SHARED_SECRET = "7baa6fde45a3df7308c6ca288b3072da9b066182dcbc8370";
  var SHOP_KEY_MAP = { queens: 'elmhurst', brooklyn: 'brooklyn', lic: 'long-island-city', flushing: 'flushing' };

  function to24Hour(display){
    var m = /^(\d{1,2}):(\d{2})\s*(AM|PM)$/i.exec(display || '');
    if(!m) return '';
    var h = parseInt(m[1], 10);
    var min = m[2];
    var ampm = m[3].toUpperCase();
    if(ampm === 'PM' && h !== 12) h += 12;
    if(ampm === 'AM' && h === 12) h = 0;
    return (h < 10 ? '0' + h : h) + ':' + min;
  }

  function submitBookingToCalendar(){
    var btn = document.getElementById('wq-confirm-booking');
    var statusEl = document.getElementById('wq-confirm-status');
    if(!btn || !statusEl) return;

    var shop = SHOPS[state.shop];
    var bridgeShopKey = SHOP_KEY_MAP[state.shop];
    if(!shop || !bridgeShopKey){
      statusEl.textContent = 'Pick a shop above first.';
      statusEl.style.color = '#b45309';
      return;
    }
    if(!state.date || !state.time){
      statusEl.textContent = 'Pick a time slot above first.';
      statusEl.style.color = '#b45309';
      return;
    }

    var nameEl = document.getElementById('wq-field-name');
    var phoneEl = document.getElementById('wq-field-phone');
    var descEl = document.getElementById('wq-field-desc');
    var name = nameEl ? nameEl.value.trim() : '';
    var phone = phoneEl ? phoneEl.value.trim() : '';
    /* a booking with no number still lands; the shop can add one at the counter */
    if(phone && !/^\d{3}-\d{3}-\d{4}$/.test(phone)){
      statusEl.textContent = 'That phone number does not look right (xxx-xxx-xxxx) \u2014 fix it or leave it blank.';
      statusEl.style.color = '#b45309';
      phoneEl && phoneEl.focus();
      return;
    }

    var payload = {
      secret: BOOKING_SHARED_SECRET,
      shop: bridgeShopKey,
      name: name,
      phone: phone,
      email: emailEl ? emailEl.value.trim() : '',
      model: modelEl ? modelEl.value.trim() : '',
      ride: state.ride || '',
      issue: state.issue || '',
      desc: descEl ? descEl.value.trim() : '',
      date: state.date,
      time: to24Hour(state.time),
    };

    btn.disabled = true;
    btn.textContent = 'Booking\u2026';
    statusEl.textContent = '';

    // text/plain avoids a CORS preflight against the Apps Script endpoint.
    fetch(BOOKING_ENDPOINT, {
      method: 'POST',
      headers: { 'Content-Type': 'text/plain;charset=utf-8' },
      body: JSON.stringify(payload),
    })
      .then(function(r){ return r.json(); })
      .then(function(result){
        if(result.ok){
          btn.textContent = 'Booked \u2713';
          statusEl.textContent =
            'You\u2019re on the schedule for ' + state.dateLabel + ' \u00b7 ' + state.time + ' ET. See you at ' + shop.addr + '.';
          statusEl.style.color = '#108474';
        } else {
          throw new Error(result.error || 'Unknown error');
        }
      })
      .catch(function(){
        btn.disabled = false;
        btn.textContent = 'Book Your Repair Now';
        statusEl.textContent = 'Couldn\u2019t reach the shop\u2019s calendar \u2014 please call or text ' + shop.telDisplay + ' instead.';
        statusEl.style.color = '#b91c1c';
      });
  }

  var confirmBookingBtn = document.getElementById('wq-confirm-booking');
  if(confirmBookingBtn) confirmBookingBtn.addEventListener('click', submitBookingToCalendar);

  root.addEventListener('input', function(e){
    var t = e.target;
    if(t && (t.id === 'wq-field-name' || t.id === 'wq-field-phone' || t.id === 'wq-field-desc')) buildLinks();
  });

  /* Phone field: digits only, auto-formatted as xxx-xxx-xxxx */
  var phoneFmtEl = document.getElementById('wq-field-phone');
  if(phoneFmtEl){
    phoneFmtEl.addEventListener('input', function(){
      var d = phoneFmtEl.value.replace(/\D/g, '').slice(0, 10);
      var out = d;
      if(d.length > 6) out = d.slice(0,3) + '-' + d.slice(3,6) + '-' + d.slice(6);
      else if(d.length > 3) out = d.slice(0,3) + '-' + d.slice(3);
      phoneFmtEl.value = out;
    });
  }

  /* Name & phone are required before sending booking via Text */
  function requireContactFields(e){
    var nEl = document.getElementById('wq-field-name');
    var pEl = document.getElementById('wq-field-phone');
  }
  var ctaTextGate = document.getElementById('wq-cta-text');
  if(ctaTextGate) ctaTextGate.addEventListener('click', requireContactFields);
  var ctaEmailGate = document.getElementById('wq-cta-email');
  if(ctaEmailGate) ctaEmailGate.addEventListener('click', requireContactFields);

  /* Ride: single select, auto-advance */
  root.querySelectorAll('.wq-bp-pill').forEach(function(btn){
    btn.addEventListener('click', function(){
      var f = btn.dataset.field;
      state[f] = btn.dataset.value;
      btn.parentElement.querySelectorAll('.wq-picked').forEach(function(b){ b.classList.remove('wq-picked'); });
      btn.classList.add('wq-picked');
      setPass(f, btn.dataset.short || btn.dataset.value);
      setTimeout(function(){ if(step < TOTAL) show(step+1); }, 200);
    });
  });

  /* Issues: multi-select toggles + Continue */
  state.issues = [];
  var issuesContinue = document.getElementById('wq-issues-continue');
  function syncIssues(){
    state.issue = state.issues.map(function(o){ return o.value; }).join(', ');
    var shorts = state.issues.map(function(o){ return o.short; });
    setPass('issue', shorts.length ? (shorts.length > 2 ? shorts.slice(0,2).join(' + ') + ' +' + (shorts.length-2) : shorts.join(' + ')) : '');
    if(issuesContinue){ issuesContinue.disabled = state.issues.length === 0; issuesContinue.textContent = state.issues.length ? ('Continue with ' + state.issues.length + ' selected \u2192') : 'Continue \u2192'; }
  }
  root.querySelectorAll('.wq-bp-issue').forEach(function(btn){
    btn.setAttribute('aria-pressed', 'false');
    btn.addEventListener('click', function(){
      var val = btn.dataset.value, sh = btn.dataset.short || val;
      var idx = state.issues.findIndex(function(o){ return o.value === val; });
      if(idx > -1){
        state.issues.splice(idx, 1);
        btn.classList.remove('wq-picked');
        btn.setAttribute('aria-pressed', 'false');
      } else {
        state.issues.push({ value: val, short: sh });
        btn.classList.add('wq-picked');
        btn.setAttribute('aria-pressed', 'true');
      }
      syncIssues();
    });
  });
  if(issuesContinue){
    issuesContinue.addEventListener('click', function(){
      if(state.issues.length && step < TOTAL) show(step+1);
    });
  }

  /* Shop step: select, route contact, reset the time step for the new shop's hours */
  root.querySelectorAll('.wq-bp-shop').forEach(function(btn){
    btn.addEventListener('click', function(){
      var key = btn.dataset.value;
      var changed = state.shop && state.shop !== key;
      state.shop = key;
      btn.parentElement.querySelectorAll('.wq-picked').forEach(function(b){ b.classList.remove('wq-picked'); });
      btn.classList.add('wq-picked');
      var shop = SHOPS[key];
      setPass('shop', shop.shortName);
      if(topLocEl) topLocEl.innerHTML = '<i aria-hidden="true"></i>' + esc(shop.addr) + ' · ' + (shopClosedSunday(key) ? 'Mon–Sat 10:30–7, closed Sunday' : 'Open 7 days, 10:30–7');
      if(changed || true){
        state.date = ''; state.dateLabel = ''; state.time = '';
        setPass('slot', '');
        if(daysEl) daysEl.innerHTML = '';
        if(timesEl) timesEl.innerHTML = '';
        if(dayLabelEl) dayLabelEl.textContent = '';
      }
      setTimeout(function(){ if(step < TOTAL) show(step+1); }, 200);
    });
  });
  if(back) back.addEventListener('click', function(){ if(step > 1) show(step-1); });
  show(1);

  /* ---------- Time step: 14-day strip + 15-min slots, per selected shop's hours ---------- */
  var MONTH_NAMES = ['January','February','March','April','May','June','July','August','September','October','November','December'];
  var DOW_NAMES = ['Sun','Mon','Tue','Wed','Thu','Fri','Sat'];

  function nyTodayParts(){
    try {
      var parts = new Intl.DateTimeFormat('en-US', {
        timeZone:'America/New_York', year:'numeric', month:'numeric', day:'numeric'
      }).formatToParts(new Date());
      var o = {};
      parts.forEach(function(pp){
        if(pp.type === 'year') o.year = parseInt(pp.value, 10);
        if(pp.type === 'month') o.month = parseInt(pp.value, 10);
        if(pp.type === 'day') o.day = parseInt(pp.value, 10);
      });
      return o;
    } catch(e){
      var dd = new Date();
      return { year:dd.getFullYear(), month:dd.getMonth()+1, day:dd.getDate() };
    }
  }
  var todayNY = nyTodayParts();

  function dateKeyFor(y, m, dd){ return y + '-' + ('0'+m).slice(-2) + '-' + ('0'+dd).slice(-2); }
  function parseDateKey(key){
    var pp = key.split('-').map(Number);
    return { y:pp[0], m:pp[1], d:pp[2] };
  }
  function formatDateLabel(key){
    var pp = parseDateKey(key);
    var dt = new Date(pp.y, pp.m - 1, pp.d);
    return DOW_NAMES[dt.getDay()] + ', ' + MONTH_NAMES[pp.m - 1].slice(0,3) + ' ' + pp.d;
  }

  function buildTimeSlots(dateKey){
    var pp = parseDateKey(dateKey);
    if(shopClosedSunday(state.shop) && new Date(pp.y, pp.m - 1, pp.d).getDay() === 0) return []; // closed Sunday
    var h = shopHoursForMonth(state.shop || 'queens', pp.m);
    var lastSlot = h.close - 60;
    var isToday = (pp.y === todayNY.year && pp.m === todayNY.month && pp.d === todayNY.day);
    var startMin;
    if(isToday){
      var et = etParts();
      var nowMins = et.hour * 60 + et.minute;
      startMin = Math.ceil((nowMins + 15) / 15) * 15;
      if(startMin < h.open) startMin = h.open;
    } else {
      startMin = h.open;
    }
    var slots = [];
    for(var t = startMin; t <= lastSlot; t += 15){ slots.push(t); }
    return slots;
  }

  function renderTimeSlots(){
    if(!timesEl) return;
    timesEl.innerHTML = '';
    if(dayLabelEl) dayLabelEl.textContent = '\u00b7 ' + state.dateLabel;
    var slots = buildTimeSlots(state.date);
    if(!slots.length){
      timesEl.innerHTML = '<p class="wq-bp-noslots">No more slots on ' + esc(state.dateLabel) + ' \u2014 pick another day, or just walk in and we\u2019ll fit you in.</p>';
      return;
    }
    slots.forEach(function(mins){
      var label = fmt12(mins);
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'wq-bp-time';
      b.textContent = label;
      b.addEventListener('click', function(){
        timesEl.querySelectorAll('.wq-bp-time').forEach(function(o){ o.classList.remove('wq-picked'); });
        b.classList.add('wq-picked');
        state.time = label;
        setPass('slot', state.dateLabel + ' \u00b7 ' + label);
        setTimeout(function(){ if(step < TOTAL) show(step + 1); }, 200);
      });
      timesEl.appendChild(b);
    });
  }

  function selectDate(key, btnEl){
    state.date = key;
    state.dateLabel = formatDateLabel(key);
    state.time = '';
    if(daysEl) daysEl.querySelectorAll('.wq-bp-day').forEach(function(b){ b.classList.remove('wq-picked'); });
    if(btnEl) btnEl.classList.add('wq-picked');
    renderTimeSlots();
  }

  function buildDayStrip(){
    if(!daysEl) return;
    daysEl.innerHTML = '';
    var base = new Date(todayNY.year, todayNY.month - 1, todayNY.day);
    for(var i = 0; i < 14; i++){
      var dt = new Date(base.getFullYear(), base.getMonth(), base.getDate() + i);
      var key = dateKeyFor(dt.getFullYear(), dt.getMonth() + 1, dt.getDate());
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'wq-bp-day';
      btn.dataset.value = key;
      btn.innerHTML = '<small>' + (i === 0 ? 'Today' : (i === 1 ? 'Tmrw' : DOW_NAMES[dt.getDay()])) + '</small><b>' + dt.getDate() + '</b><span>' + MONTH_NAMES[dt.getMonth()].slice(0,3) + '</span>';
      if(i === 0 && buildTimeSlots(key).length === 0) btn.disabled = true;
      if(shopClosedSunday(state.shop) && dt.getDay() === 0){ btn.disabled = true; btn.title = 'Closed Sunday'; }
      btn.addEventListener('click', function(){
        if(this.disabled) return;
        selectDate(this.dataset.value, this);
      });
      daysEl.appendChild(btn);
    }
  }

  function initDateTimeStep(){
    buildDayStrip();
    var firstBtn = daysEl ? daysEl.querySelector('.wq-bp-day:not(:disabled)') : null;
    if(firstBtn) selectDate(firstBtn.dataset.value, firstBtn);
  }

  /* ---------- Why Wilson's — expanding panels ---------- */
  (function(){
    var wrap = document.getElementById('wq-why-x');
    if(!wrap) return;
    var panels = wrap.querySelectorAll('.wq-why-p');
    panels.forEach(function(p){
      p.addEventListener('click', function(){
        if(p.classList.contains('wq-why-open')) return;
        panels.forEach(function(o){
          o.classList.toggle('wq-why-open', o === p);
          o.setAttribute('aria-expanded', o === p ? 'true' : 'false');
        });
      });
    });
  })();

  /* ---------- Express bench interactive ---------- */
  (function(){
    var xpData = [
      { name:'Flat Tire Repair', tag:'Pothole and glass punctures, patched while you wait.', price:'From $40', mins:20,
        icon:'https://cdn.shopify.com/s/files/1/0983/6625/9510/files/w1.png?v=1778773439',
        list:['The starting price comes first, and we start only on your approval','New inner tube fitted, seated right, inflated to spec and spin-checked','One quick test ride outside before it\u2019s back in your hands'],
        note:'<b>Good to know:</b> Solid, tubed and tubeless all welcome, in every common wheel size. With a stocked parts wall, there\u2019s no waiting on orders.' },
      { name:'Tire & Tube Replacement', tag:'New rubber for New York streets, installed on the spot.', price:'From $65', mins:20,
        icon:'https://cdn.shopify.com/s/files/1/0983/6625/9510/files/w2.png?v=1778773444',
        list:['Street, off-road and no-flat choices stocked for most brands','New tire and tube fitted, wheel and bearing cleaned and oiled, pressure-set for city riding','The old parts get recycled, so you walk out hands-free'],
        note:'<b>Good to know:</b> Ask us about no-flat tires. Plenty of NYC riders never see another puncture.' },
      { name:'Brake Repair', tag:'Sure, safe stopping for boulevard stop-and-go.', price:'From $25', mins:15,
        icon:'https://cdn.shopify.com/s/files/1/0983/6625/9510/files/w3.png?v=1778773447',
        list:['Full brake check: pads, disc, clearance and bearings','Disc, drum and hydraulic care: adjustments, bleeds and replacements','A stop test at the store before your ride leaves'],
        note:'<b>Good to know:</b> Boulevard stop-and-go wears brake pads down fast. Stop by any time we\u2019re open.' },
      { name:'Throttle Repair', tag:'Throttle response restored, smooth and predictable.', price:'From $50', mins:30,
        icon:'https://cdn.shopify.com/s/files/1/0983/6625/9510/files/w4.png?v=1778773434',
        list:['Signal tested at the connector to isolate the throttle fault','Repaired or replaced same day from the parts wall','A test ride confirms clean acceleration before hand-back'],
        note:'<b>Good to know:</b> Surging, lag or dead spots usually trace to the throttle, not the motor. That\u2019s easier on your wallet.' },
      { name:'Lighting Repair', tag:'Headlights, taillights, LEDs and wiring, seen and street-legal.', price:'From $35', mins:30,
        icon:'https://cdn.shopify.com/s/files/1/0983/6625/9510/files/w5.png?v=1778773442',
        list:['Bulbs, LED strips, signals and entire wiring harnesses covered','Corroded connectors cleaned and resealed against slush and salt','End-to-end visibility check so you ride legal after dark'],
        note:'<b>Good to know:</b> NYC requires a white front light and a red rear light after dark. We\u2019ll make sure you\u2019re covered.' },
      { name:'Error Code Fix', tag:'Code read for free, cause found, fix quoted.', price:'Read free · fix from $35', mins:5,
        icon:'https://cdn.shopify.com/s/files/1/0983/6625/9510/files/w6.png?v=1778773436',
        list:['Any brand\u2019s codes read on the spot, free','The fault isolated to its exact component, nothing guessed','You leave with a written quote and zero obligation'],
        note:'<b>Good to know:</b> Reading the code is free. Fixing the fault behind it starts at $35, and nothing begins without your OK on the price.' }
    ];
    var picks = root.querySelectorAll('.wq-xp-pick');
    var panel = document.getElementById('wq-xp-panel');
    if(!picks.length || !panel) return;
    var elIcon = document.getElementById('wq-xp-icon'),
        elName = document.getElementById('wq-xp-name'),
        elTag = document.getElementById('wq-xp-tag'),
        elPrice = document.getElementById('wq-xp-price'),
        elMins = document.getElementById('wq-xp-mins'),
        elList = document.getElementById('wq-xp-list'),
        elNote = document.getElementById('wq-xp-note'),
        elDial = document.getElementById('wq-xp-dial-fill');
    var CIRC = 232.5, MAX_MIN = 30;
    var checkSvg = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M20 6L9 17l-5-5"/></svg>';
    function setXp(i, focus){
      var d = xpData[i];
      picks.forEach(function(btn, j){
        var on = j === i;
        btn.setAttribute('aria-selected', on ? 'true' : 'false');
        btn.tabIndex = on ? 0 : -1;
        if(on && focus) btn.focus();
      });
      panel.setAttribute('aria-labelledby', 'wq-xp-tab-' + i);
      panel.classList.remove('wq-xp-swap');
      void panel.offsetWidth;
      panel.classList.add('wq-xp-swap');
      elIcon.src = d.icon; elIcon.alt = d.name + ' icon';
      elName.textContent = d.name;
      elTag.textContent = d.tag;
      elPrice.textContent = d.price;
      elMins.textContent = d.mins;
      elList.innerHTML = d.list.map(function(t){ return '<li>' + checkSvg + '<span>' + t + '</span></li>'; }).join('');
      elNote.innerHTML = d.note;
      var frac = Math.min(d.mins / MAX_MIN, 1);
      if(reduce){ elDial.style.transition = 'none'; }
      elDial.style.strokeDashoffset = (CIRC * (1 - frac)).toFixed(1);
    }
    picks.forEach(function(btn){
      btn.addEventListener('click', function(){ setXp(parseInt(btn.dataset.xp, 10), false); });
      btn.addEventListener('keydown', function(e){
        var i = parseInt(btn.dataset.xp, 10), n = picks.length;
        if(e.key === 'ArrowDown' || e.key === 'ArrowRight'){ e.preventDefault(); setXp((i + 1) % n, true); }
        if(e.key === 'ArrowUp' || e.key === 'ArrowLeft'){ e.preventDefault(); setXp((i - 1 + n) % n, true); }
        if(e.key === 'Home'){ e.preventDefault(); setXp(0, true); }
        if(e.key === 'End'){ e.preventDefault(); setXp(n - 1, true); }
      });
    });
    setXp(0, false);

    /* Mobile only: slow auto-scroll nudge so the row doesn't read as static —
       stops for good the instant the person touches or scrolls it themselves. */
    var xpList = document.getElementById('wq-xp-picklist');
    if(xpList && !reduce && matchMedia('(max-width:640px)').matches){
      var xpAuto = true, xpDir = 1, xpPauseUntil = 0;
      ['pointerdown','wheel','touchstart'].forEach(function(evt){
        xpList.addEventListener(evt, function(){ xpAuto = false; }, { passive:true });
      });
      function xpTick(ts){
        if(!xpAuto) return;
        var max = xpList.scrollWidth - xpList.clientWidth;
        if(max <= 4){ return; }
        if(ts >= xpPauseUntil){
          xpList.scrollLeft += 0.5 * xpDir;
          if(xpList.scrollLeft >= max - 1){ xpDir = -1; xpPauseUntil = ts + 1100; }
          else if(xpList.scrollLeft <= 1){ xpDir = 1; xpPauseUntil = ts + 1100; }
        }
        requestAnimationFrame(xpTick);
      }
      setTimeout(function(){ requestAnimationFrame(xpTick); }, 1000);
    }
  })();

  /* ---------- Smooth anchor scroll ---------- */
  root.querySelectorAll('a[href^="#"]').forEach(function(a){
    a.addEventListener('click', function(e){
      var id = a.getAttribute('href').slice(1);
      var el = document.getElementById(id);
      if(!el) return;
      e.preventDefault();
      var y = el.getBoundingClientRect().top + window.pageYOffset - 64;
      window.scrollTo({ top:y, behavior: reduce ? 'auto' : 'smooth' });
    });
  });

  /* ---------- Crew console (Meet the team) ---------- */
  (function(){
    var crew = root.querySelector('#wq-crew');
    if(!crew) return;
    var tabs = Array.prototype.slice.call(crew.querySelectorAll('.wq-crew-tab'));
    var panes = Array.prototype.slice.call(crew.querySelectorAll('.wq-crew-pane'));
    var idx = 0, timer = null, userTouched = false;

    function show(i){
      idx = (i + tabs.length) % tabs.length;
      tabs.forEach(function(t, n){
        var on = n === idx;
        t.setAttribute('aria-selected', on ? 'true' : 'false');
        t.setAttribute('tabindex', on ? '0' : '-1');
        var prog = t.querySelector('.wq-crew-prog');
        if(prog){
          prog.classList.remove('wq-run');
          if(on && !userTouched && !reduce){ void prog.offsetWidth; prog.classList.add('wq-run'); }
        }
      });
      panes.forEach(function(p, n){
        var on = n === idx;
        p.hidden = !on;
        p.classList.remove('wq-on');
        if(on){ void p.offsetWidth; p.classList.add('wq-on'); }
      });
    }

    function stopAuto(){
      userTouched = true;
      if(timer){ clearInterval(timer); timer = null; }
      tabs.forEach(function(t){ var p = t.querySelector('.wq-crew-prog'); if(p) p.classList.remove('wq-run'); });
    }

    tabs.forEach(function(t, n){
      t.addEventListener('click', function(){ stopAuto(); show(n); });
      t.addEventListener('keydown', function(e){
        if(e.key === 'ArrowRight' || e.key === 'ArrowDown'){ e.preventDefault(); stopAuto(); show(idx + 1); tabs[idx].focus(); }
        if(e.key === 'ArrowLeft' || e.key === 'ArrowUp'){ e.preventDefault(); stopAuto(); show(idx - 1); tabs[idx].focus(); }
      });
    });

    /* Auto-rotate once the section is in view; stop forever on first tap */
    function startAuto(){
      if(reduce || userTouched || timer) return;
      /* No auto-rotation on touch devices: pane swaps mid-scroll caused layout
         shifts that made the page feel stuck around the gallery below. */
      if(matchMedia('(hover:none),(pointer:coarse)').matches) return;
      show(idx);
      timer = setInterval(function(){ if(!userTouched) show(idx + 1); }, 7000);
    }
    if('IntersectionObserver' in window){
      var cio = new IntersectionObserver(function(entries){
        entries.forEach(function(en){
          if(en.isIntersecting){ startAuto(); }
          else if(timer){ clearInterval(timer); timer = null; tabs.forEach(function(t){ var p=t.querySelector('.wq-crew-prog'); if(p) p.classList.remove('wq-run'); }); }
        });
      },{ threshold:.35 });
      cio.observe(crew);
    } else { startAuto(); }

    show(0);
  })();

  /* ---------- Scroll-reveal ---------- */
  var revealTargets = root.querySelectorAll('.wq-xp-promise,.wq-xp-bench,.wq-svc-row,.wq-ride,.wq-station,.wq-proc-step,.wq-why-p,.wq-faq details,.wq-contact-card,.wq-xgal,.wq-live-card,.wq-final-opt,.wq-crew,.wq-perk-row,.wq-map-card,.wq-gmb-btn,.wq-loc-card');
  if(!reduce && 'IntersectionObserver' in window){
    revealTargets.forEach(function(el,i){
      el.classList.add('wq-reveal');
      el.style.transitionDelay = (i % 4) * 70 + 'ms';
    });
    var io = new IntersectionObserver(function(entries){
      entries.forEach(function(en){
        if(en.isIntersecting){ en.target.classList.add('wq-in'); io.unobserve(en.target); }
      });
    },{ threshold:.12 });
    revealTargets.forEach(function(el){ io.observe(el); });
  }

  /* ---------- Stat count-up ---------- */
  var counters = root.querySelectorAll('.wq-count');
  function runCount(el){
    var target = parseFloat(el.dataset.target), suffix = el.dataset.suffix || '';
    var dec = parseInt(el.dataset.decimals || '0', 10);
    if(reduce){ el.textContent = target.toFixed(dec) + suffix; return; }
    var start = null, DUR = 1200;
    function tick(ts){
      if(!start) start = ts;
      var p = Math.min((ts - start) / DUR, 1);
      var eased = 1 - Math.pow(1 - p, 3);
      el.textContent = (target * eased).toFixed(dec) + suffix;
      if(p < 1) requestAnimationFrame(tick);
    }
    requestAnimationFrame(tick);
  }
  if('IntersectionObserver' in window){
    var cio = new IntersectionObserver(function(entries){
      entries.forEach(function(en){
        if(en.isIntersecting){ runCount(en.target); cio.unobserve(en.target); }
      });
    },{ threshold:.5 });
    counters.forEach(function(c){ cio.observe(c); });
  } else {
    counters.forEach(runCount);
  }

  /* ---------- Repair guide tabs ---------- */
  var guideRoot = document.getElementById('wq-guide');
  if(guideRoot){
    var guideTabs = guideRoot.querySelectorAll('.wq-guide-tab');
    var guidePanels = guideRoot.querySelectorAll('.wq-guide-panel');
    guideRoot.classList.add('wq-guide-ready');

    function activateGuide(key){
      guideTabs.forEach(function(t){
        var on = t.dataset.guide === key;
        t.classList.toggle('wq-guide-tab-active', on);
        t.setAttribute('aria-selected', on ? 'true' : 'false');
      });
      guidePanels.forEach(function(p){
        p.classList.toggle('wq-guide-panel-active', p.dataset.guidePanel === key);
      });
    }
    guideTabs.forEach(function(tab, i){
      tab.addEventListener('click', function(){ activateGuide(tab.dataset.guide); });
      tab.addEventListener('keydown', function(e){
        if(e.key !== 'ArrowDown' && e.key !== 'ArrowUp' && e.key !== 'ArrowRight' && e.key !== 'ArrowLeft') return;
        e.preventDefault();
        var dir = (e.key === 'ArrowDown' || e.key === 'ArrowRight') ? 1 : -1;
        var next = guideTabs[(i + dir + guideTabs.length) % guideTabs.length];
        next.focus();
        activateGuide(next.dataset.guide);
      });
    });
  }

  /* ---------- Google Business Profile panel: live open status + star pop ---------- */
  (function(){
    var starsEl = document.getElementById('wq-google-stars');
    if(starsEl){
      var chars = starsEl.textContent.trim().split('');
      starsEl.innerHTML = chars.map(function(ch){ return '<span>' + ch + '</span>'; }).join('');
      if('IntersectionObserver' in window){
        var sio = new IntersectionObserver(function(entries){
          entries.forEach(function(en){
            if(en.isIntersecting){ starsEl.classList.add('wq-stars-in'); sio.unobserve(en.target); }
          });
        }, { threshold:.6 });
        sio.observe(starsEl);
      } else { starsEl.classList.add('wq-stars-in'); }
    }
  })();

  /* ---------- GBP rating badge: star fill on scroll ---------- */
  (function(){
    var scoreEl = document.getElementById('wq-gbp-score');
    if(!scoreEl) return;
    if('IntersectionObserver' in window){
      var gio = new IntersectionObserver(function(entries){
        entries.forEach(function(en){
          if(en.isIntersecting){ scoreEl.classList.add('wq-gr-in'); gio.unobserve(en.target); }
        });
      }, { threshold:.5 });
      gio.observe(scoreEl);
    } else { scoreEl.classList.add('wq-gr-in'); }
  })();

  /* ---------- FAQ search + category filter ---------- */
  var faqList = document.getElementById('wq-faq-list');
  if(faqList){
    var faqItems = faqList.querySelectorAll('details');
    var faqChips = root.querySelectorAll('.wq-faq-chip');
    var faqSearch = document.getElementById('wq-faq-search');
    var faqCountEl = document.getElementById('wq-faq-count');
    var faqEmptyEl = document.getElementById('wq-faq-empty');
    var activeCat = 'all';

    function faqApply(){
      var q = (faqSearch && faqSearch.value || '').trim().toLowerCase();
      var shown = 0;
      faqItems.forEach(function(item){
        var matchesCat = activeCat === 'all' || item.dataset.cat === activeCat;
        var text = item.textContent.toLowerCase();
        var matchesQuery = !q || text.indexOf(q) > -1;
        var visible = matchesCat && matchesQuery;
        item.classList.toggle('wq-faq-hide', !visible);
        if(visible) shown++;
      });
      if(faqCountEl) faqCountEl.textContent = shown + (shown === 1 ? ' question' : ' questions') + (activeCat !== 'all' || q ? ' match' + (shown===1?'es':'') : ' shown');
      if(faqEmptyEl) faqEmptyEl.hidden = shown !== 0;
    }
    faqChips.forEach(function(chip){
      chip.addEventListener('click', function(){
        faqChips.forEach(function(c){ c.classList.remove('wq-faq-chip-active'); });
        chip.classList.add('wq-faq-chip-active');
        activeCat = chip.dataset.cat;
        faqApply();
      });
    });
    if(faqSearch) faqSearch.addEventListener('input', faqApply);
    faqApply();
  }


  /* ---------- HUB: per-shop open/closed status on the location cards ---------- */
  (function(){
    var cards = root.querySelectorAll('.wq-loc-open');
    if(!cards.length) return;
    function etNowHub(){
      var f = new Intl.DateTimeFormat('en-US', { timeZone:'America/New_York', hour12:false, hour:'2-digit', minute:'2-digit', month:'numeric' });
      var parts = {}; f.formatToParts(new Date()).forEach(function(pp){ parts[pp.type] = pp.value; });
      return { mins: parseInt(parts.hour,10)*60 + parseInt(parts.minute,10), month: parseInt(parts.month,10) - 1 };
    }
    function hoursForHub(store, m){
      // All four NYC shops: 10:30AM-7PM year-round (Brooklyn + LIC closed Sunday)
      return {o:630,c:1140};
    }
    function hubWeekday(){ try { return new Intl.DateTimeFormat('en-US',{ timeZone:'America/New_York', weekday:'short' }).format(new Date()); } catch(e){ return ['Sun','Mon','Tue','Wed','Thu','Fri','Sat'][new Date().getDay()]; } }
    function fmtHub(mins){
      var h = Math.floor(mins/60), mm = mins % 60, ap = h >= 12 ? 'PM' : 'AM';
      h = h % 12; if(h === 0) h = 12;
      return h + (mm ? ':' + (mm<10?'0':'')+mm : '') + ' ' + ap;
    }
    function paintHub(){
      var now = etNowHub();
      cards.forEach(function(el){
        var hw = hoursForHub(el.getAttribute('data-store'), now.month);
        var store = el.getAttribute('data-store');
        var sundayClosed = (store === 'brooklyn' || store === 'lic') && hubWeekday() === 'Sun';
        var open = !sundayClosed && now.mins >= hw.o && now.mins < hw.c;
        el.classList.toggle('is-open', open);
        var txt = el.querySelector('.wq-loc-open-txt');
        if(txt) txt.textContent = open ? ('Open now \u00b7 until ' + fmtHub(hw.c) + ' ET') : (sundayClosed ? 'Closed Sunday \u00b7 opens Monday ' + fmtHub(hw.o) + ' ET' : 'Closed \u00b7 opens ' + fmtHub(hw.o) + ' ET');
      });
    }
    paintHub();
    setInterval(paintHub, 60000);
  })();

  /* ---------- HUB: daily citywide repairs counter in the final CTA ---------- */
  (function(){
    var el = document.getElementById('wq-final-count');
    if(!el) return;
    var f = new Intl.DateTimeFormat('en-US', { timeZone:'America/New_York', hour12:false, hour:'2-digit', minute:'2-digit' });
    var parts = {}; f.formatToParts(new Date()).forEach(function(pp){ parts[pp.type] = pp.value; });
    var mins = parseInt(parts.hour,10)*60 + parseInt(parts.minute,10);
    var dstr = new Intl.DateTimeFormat('en-US',{timeZone:'America/New_York'}).format(new Date());
    var seed = 0; for(var i=0;i<dstr.length;i++){ seed = (seed*31 + dstr.charCodeAt(i)) >>> 0; }
    var frac = Math.max(0, Math.min(1, (mins - 600) / 600));
    el.textContent = String(Math.round((34 + (seed % 15)) * frac));
  })();

})();
